<template>
  <div class="w-full flex flex-col gap-2">
    <div class="items-center">
      <Carousel v-bind="carouselConfig">
        <Slide
          class="w-auto mr-auto ml-auto"
          v-for="(item, index) in itemsList"
          :key="`item-${index}`"
        >
          <carousel-item :rendering="item.fields" />
        </Slide>
        <template #addons>
          <Pagination />
        </template>
      </Carousel>
    </div>
  </div>
</template>

<script>
import 'vue3-carousel/carousel.css';
import { Carousel, Slide, Pagination } from 'vue3-carousel';
import CarouselItemVue from './CarouselItem.vue';
import { ref, onMounted, onBeforeUnmount, nextTick } from 'vue';
const carouselConfig = {
  itemsToShow: 1,
  wrapAround: true,
};

export default {
  name: 'FeatureCarousel',
  props: {
    rendering: {
      type: Object,
      required: true,
    },
  },
  components: {
    Carousel,
    Pagination,
    Slide,
    'carousel-item': CarouselItemVue,
  },
  computed: {
    fields() {
      // rendering.fields are populated from route YAML (disconnected)
      // or from Layout Service (integrated)
      return this.rendering?.fields || {};
    },
    itemsList() {
      // Handle both disconnected (array) and connected (value.value array) modes
      const items = this.fields?.items;
      if (!items) return [];

      // If items has a 'value' property, it's from Layout Service (connected mode)
      if (items.value && Array.isArray(items.value)) {
        return items.value;
      }

      // Otherwise it's disconnected mode (direct array)
      if (Array.isArray(items)) {
        // In disconnected mode, wrap each item to match connected structure
        return items.map((item) => ({ fields: item }));
      }

      return [];
    },
  },
  setup(props) {
    //const carouselImageHeight = ref(0);
    //const imageHandlers = new Map();

    //function getImages() {
    //  return Array.from(document.querySelectorAll('ol.carousel__track > li > a > img'));
    //}

    //function measureHeight() {
    //  const imgs = getImages();
    //  if (!imgs.length) {
    //    carouselImageHeight.value = 0;
    //    return;
    //  }

    //  const heights = imgs.map((img) => {
    //    const rect = img.getBoundingClientRect();
    //    return rect && rect.height ? rect.height : img.clientHeight || 0;
    //  });

    //  carouselImageHeight.value = Math.max(...heights);

    //  // Attach load handlers for any new images so we re-measure when they load
    //  imgs.forEach((img) => {
    //    if (!imageHandlers.has(img)) {
    //      const handler = () => {
    //        nextTick(() => measureHeight());
    //      };
    //      img.addEventListener('load', handler);
    //      imageHandlers.set(img, handler);
    //    }
    //  });
    //}

    //function onResize() {
    //  measureHeight();
    //  setPaginationHeight();
    //}

    //function setPaginationHeight() {
    //    const paginationElement = document.querySelector('ol.carousel__pagination');
    //    if (carouselImageHeight.value < 427) {
    //        paginationElement.style.top = `${carouselImageHeight.value - 25}px`;
    //    }
    //    else {
    //        paginationElement.style.top = `385px`;
    //    }
    //}

    onMounted(() => {
      nextTick(() => {
        //measureHeight();
        //setPaginationHeight();
      });
     // window.addEventListener('resize', onResize);
    });

    onBeforeUnmount(() => {
      window.removeEventListener('resize', onResize);
      imageHandlers.forEach((handler, img) => {
        try {
          img.removeEventListener('load', handler);
        } catch (e) {
          // ignore
        }
      });
      imageHandlers.clear();
    });

    return {
      carouselConfig,
      //carouselImageHeight,
    };
  },
};
</script>

<style scoped></style>
